import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { bookableProductTemplateCreateCommandParamsZodObject } from "@@/shared/products/templates/product-templates/bookable.product-template";
import { buyableProductTemplateCreateCommandParamsZodObject } from "@@/shared/products/templates/product-templates/buyable.product-template";
import { voucherProductTemplateCreateCommandParamsZodObject } from "@@/shared/products/templates/product-templates/voucher.product-template";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

// Creates the product directly from the template data used by ai-chat
const createProductFromTemplateDataZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("CREATE_PRODUCT_FROM_TEMPLATE_DATA_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    forProviderId: providerIdZodSchema,
    templateData: z.union([
        bookableProductTemplateCreateCommandParamsZodObject,
        buyableProductTemplateCreateCommandParamsZodObject,
        voucherProductTemplateCreateCommandParamsZodObject,
    ]),
});

type CreateProductFromTemplateData = z.infer<
    typeof createProductFromTemplateDataZodObject
>;
const createProductFromTemplateDataZodSchema: z.ZodSchema<CreateProductFromTemplateData> =
    createProductFromTemplateDataZodObject;

type FactoryParams = Except<
    CreateProductFromTemplateData,
    "_id" | "_type" | "_createdAt"
>;
const createProductFromTemplateDataFactory = (params: FactoryParams) => {
    const createProductFromTemplateData: CreateProductFromTemplateData = {
        ...params,
        _id: generateId({ prefix: "command__" }),
        _type: "CREATE_PRODUCT_FROM_TEMPLATE_DATA_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return createProductFromTemplateData;
};

export {
    createProductFromTemplateDataFactory,
    createProductFromTemplateDataZodObject,
    createProductFromTemplateDataZodSchema,
};
export type { CreateProductFromTemplateData };
